import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useCalculateSize } from '../../../common/hooks/useCalculateSize'
import { Element } from '../../../common/html/element'
import { Pagination } from '../../../common/pagination'
import { Table } from '../../../common/table'
import { PAGE_SIZE_OPTIONS, TABLE_COL } from '../constant'
import {
  changeFilter,
  selectAlertById,
  selectAlertIds,
  selectFilter,
  selectLoading,
  selectTotalRecords,
} from '../store/slice'
import { CheckboxAll } from './CheckboxAll'
import classes from './index.module.scss'
import { TableCell } from './TableCell'
import { ToolBar } from './ToolBar'

export const AlertTable = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const tableRef = useRef()
  const { height } = useCalculateSize(tableRef)

  const ids = useSelector(selectAlertIds)
  const filter = useSelector(selectFilter())
  const totalRecords = useSelector(selectTotalRecords)
  const isLoading = useSelector(selectLoading('alertList'))

  const setPage = (page) => dispatch(changeFilter({ page }))
  const setPageSize = (pageSize) =>
    dispatch(changeFilter({ pageSize, page: 1 }))

  const renderPagination = () => {
    return (
      <Pagination
        page={filter.page}
        pageSize={filter.pageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        total={totalRecords}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    )
  }

  const getSchema = () => {
    return Object.keys(TABLE_COL).map((key) => {
      const title = `alerts.${key}`
      const colId = TABLE_COL[key]
      const tdStyle = {
        width: [TABLE_COL.CHECKBOX, TABLE_COL.DELETE].includes(colId) ? 50 : '',
      }

      return {
        colId,
        title,
        isI18n: true,
        tdStyle,
        renderTh: (title) => {
          switch (colId) {
            case TABLE_COL.CHECKBOX:
              return <CheckboxAll />
            case TABLE_COL.DELETE:
              return ''
            default:
              return title
          }
        },
        render: (data, { rowId }) => (
          <TableCell data={data} colId={colId} rowId={rowId} />
        ),
      }
    })
  }

  const onRowClick = (rowId) => {
    navigate(`/alerts/${rowId}`)
  }

  return (
    <Element className={classes.container}>
      <ToolBar />
      <Element ref={tableRef} className={classes.table}>
        <Element className={classes.tableContent}>
          <Table
            ids={ids}
            getDataFromRedux={selectAlertById}
            isLoading={isLoading}
            schema={getSchema()}
            renderPagination={renderPagination}
            onRowClick={onRowClick}
            isNoDataWithHead
            isCenterNoData={false}
            noDataText="alerts.NO_ALERT_TO_DISPLAY"
            keyReCalculateSize={height}
          />
        </Element>
      </Element>
    </Element>
  )
}
